<template>
  <div id="ErrorPage">
    <h2>發生錯誤</h2>
    <p v-html="msg"></p>
    <router-link to="/">回到首頁</router-link>
  </div>
</template>

<script>
export default {
  name: "PayError",
  data() {
    return {
      msg:
        "發生無法預期的錯誤，您的付款或訂單並未成功。 <br />若有任何疑慮或問題持續發生請與我們聯絡。",
    };
  },
  created() {
    window.prerenderReady = true;
    if (this.$route.query.message) {
      this.msg = this.$route.query.message;
    }
  },

  metaInfo() {
    return {
      title: "付款失敗｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "付款失敗｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "付款失敗｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "付款失敗｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
